import { skipToken, useMutation, useQuery } from "@tanstack/react-query"
import { acceptRetentionOffer, getRetentionOffers } from "./retention"
import type { IUserIdParams } from "@commonTypes/user"
import { accountKeys } from "@apis/accounts/queryKeys"

export const useGetRetentionOffersQuery = (
  account_id: string,
  params: IUserIdParams,
  isEnabled: boolean = true,
) => {
  return useQuery({
    queryKey: accountKeys.retentionOffersForAccount(account_id, params),
    queryFn: isEnabled
      ? () => getRetentionOffers(account_id, params)
      : skipToken,
    select: (response) => ({
      ...response.data,
      requestId: response.headers["x-request-id"]?.split("-")[0] ?? "",
    }),
  })
}

export const useAcceptRetentionOfferMutation = () => {
  return useMutation({
    mutationFn: acceptRetentionOffer,
  })
}
